import { Form, Input, Select } from 'antd';

import Modal from 'components/Modals/Modal/Modal';
import useLarApi from '../LarAppNew/hooks/useLarApi';

const reasonOptions = [
  { value: 'Rewrite an d improve the business plan' },
  { value: 'Lower the LTV/LTC' },
  { value: 'Correct the historical or proforma figures' },
  { value: 'Provide the construction/renovation budget' },
  { value: 'Provide at least one picture' },
  { value: 'Provide more information about the borrower’s experience' },
  { value: 'There are no Starport lenders for this request' },
  { value: 'Other reason - See text' },
];

export default function RejectDealModal({ id, loading, onCancel, ...rest }) {
  const { rejectLar } = useLarApi();
  const [form] = Form.useForm();

  const onReject = async (data) => {
    await rejectLar({
      lar_id: +id,
      ...data,
    }).then(() => {
      onCancel();
    });
  };

  return (
    <Modal
      {...rest}
      cancelText="Close"
      okText="Confirm"
      onCancel={onCancel}
      onOk={() => form.submit()}
      title="Reject a deal"
      okButtonProps={{ loading }}
    >
      <Form
        layout="vertical"
        form={form}
        initialValues={{ reason: reasonOptions[0].value }}
        requiredMark={false}
        onFinish={onReject}
      >
        <Form.Item label="Why are you ending this deal?" name="reason">
          <Select options={reasonOptions} />
        </Form.Item>
        <Form.Item
          name="text"
          rules={[
            { required: true, message: 'Additional explanation is required' },
            { max: 500, message: 'The input exceeds the maximum length of 500 characters' },
          ]}
          label="Please provide an additional explanation for the lender(s):"
        >
          <Input.TextArea />
        </Form.Item>
      </Form>
    </Modal>
  );
}
